const zones = [
	{
		zoneId: 1,
		name: 'Leaderboard',
		banners: [
			{
				type: 'iframe',
				tag: 'banner',
				dimensions: [970, 210],
				url: 'leaderboard/leaderboard-banner-970-210.html',
			},
			{
				type: 'iframe',
				tag: 'kombi',
				dimensions: [970, 210],
				url: 'leaderboard/leaderboard-kombi.html',
			},
			{
				type: 'iframe',
				tag: 'drtg',
				dimensions: [970, 210],
				url: 'leaderboard/leaderboard-drtg.html',
			},
		],
	},
	{
		zoneId: 2,
		name: 'SMR',
		banners: [
			{
				type: 'iframe',
				tag: 'banner',
				dimensions: [300, 250],
				url: 'square/square-300-250-banner.html',
			},
			{
				type: 'iframe',
				tag: 'banner',
				dimensions: [300, 300],
				url: 'square/square-300-300-banner-2.html',
			},
			{
				type: 'iframe',
				tag: 'drtg',
				dimensions: [300, 300],
				url: 'square/square-300-300-drtg.html',
			},
			{
				type: 'iframe',
				tag: 'kombi',
				dimensions: [300, 300],
				url: 'square/square-300-300-kombi.html',
			},
		],
	},
	{
		zoneId: 3,
		name: 'Native - related articles',
		banners: [
			{
				type: 'native',
				tag: 'drtg',
				url: 'native/related-articles-drtg.html',
				caption: true,
			},
			{
				type: 'native',
				tag: 'kombi',
				url: 'native/related-articles-kombi.html',
				caption: true,
			},
		],
	},
	{
		zoneId: 4,
		name: 'Native - sidebar',
		banners: [
			{
				type: 'native',
				tag: 'drtg',
				url: 'native/sidebar-article-drtg.html',
				caption: true,
			},
			{
				type: 'native',
				tag: 'kombi',
				url: 'native/sidebar-article-kombi.html',
				caption: true,
			},
		],
	},
	{
		zoneId: 5,
		name: 'SMR v textu',
		banners: [
			{
				type: 'iframe',
				tag: 'banner',
				dimensions: [300, 250],
				url: 'square/square-300-250-banner.html',
			},
			{
				type: 'iframe',
				tag: 'banner',
				dimensions: [300, 300],
				url: 'square/square-300-300-banner-2.html',
			},
			{
				type: 'iframe',
				tag: 'banner',
				dimensions: [480, 300],
				url: 'square/square-480-300-banner.html',
			},
			{
				type: 'iframe',
				tag: 'drtg',
				dimensions: [300, 300],
				url: 'square/square-300-300-drtg.html',
			},
			{
				type: 'iframe',
				tag: 'kombi',
				dimensions: [300, 300],
				url: 'square/square-300-300-kombi.html',
			},
		],
	},
	{
		zoneId: 6,
		name: 'Wallpaper',
		banners: [
			{
				type: 'iframe',
				tag: 'drtg',
				dimensions: [480, 300],
				url: 'wallpaper/wp-480-300-drtg.html',
			},
			{
				type: 'iframe',
				tag: 'kombi',
				dimensions: [480, 300],
				url: 'wallpaper/wp-480-300-kombi.html',
			},
		],
	},
	{
		zoneId: 7,
		name: 'Skyscraper',
		banners: [
			{
				type: 'iframe',
				tag: 'banner',
				dimensions: [300, 250],
				url: 'square/square-300-250-banner.html',
			},
			{
				type: 'iframe',
				tag: 'banner',
				dimensions: [300, 300],
				url: 'square/square-300-300-banner-2.html',
			},
			{
				type: 'iframe',
				tag: 'banner',
				dimensions: [300, 600],
				url: 'sky/sky-300-600-banner.html',
			},
			{
				type: 'iframe',
				tag: 'drtg',
				dimensions: [300, 600],
				url: 'sky/sky-300-600-drtg.html',
			},
			{
				type: 'iframe',
				tag: 'kombi',
				dimensions: [300, 600],
				url: 'sky/sky-300-600-kombi.html',
			},
		],
	},
	{
		zoneId: 8,
		name: 'Rectangle',
		banners: [
			{
				type: 'iframe',
				tag: 'banner',
				dimensions: [970, 310],
				url: 'rectangle/rectangle-970-310.html',
			},
			{
				type: 'iframe',
				tag: 'banner',
				dimensions: [970, 210],
				url: 'leaderboard/leaderboard-banner-970-210.html',
			},
			{
				type: 'iframe',
				tag: 'drtg',
				dimensions: [970, 310],
				url: 'rectangle/rectangle-970-310-drtg.html',
			},
			{
				type: 'iframe',
				tag: 'kombi',
				dimensions: [970, 310],
				url: 'rectangle/rectangle-970-310-kombi.html',
			},
		],
	},
	{
		zoneId: 9,
		name: 'Textovy Sklik mobil',
		banners: [
			{
				type: 'iframe',
				tag: 'kombi',
				dimensions: [300, 250],
				url: 'pod-clankem/mobile-text-300-250.html',
			},
			{
				type: 'iframe',
				tag: 'drtg',
				dimensions: [300, 250],
				url: 'pod-clankem/mobile-text-300-250.html',
			},
		],
	},
];

export { zones };
